<template>
  <v-app id="selectLanguage">
    <tool-bar>
      <slot><h3>{{ condition.name }} {{ getSelectedVisa.type }} </h3></slot>
    </tool-bar>
    <v-content class="pt-0">
      <v-container fluid>
        <v-layout justify-center>
          <v-card>
            <v-toolbar class="elevation-0" color="none">
              <v-toolbar-title>
                <b class="text-primary">Dear {{ visa.traveller.full_name }} , please confirm your
                  information:</b>
              </v-toolbar-title>
              <v-spacer/>
            </v-toolbar>

            <v-card-text class="pt-0">
              <v-layout row style="background: #ffffff" wrap>
                <v-flex xs12 v-if="showOnlinePayment">
                  <v-alert type="info" outlined>
                    {{ $vuetify.lang.t('$vuetify.charge_detail') }}
                  </v-alert>
                </v-flex>
                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.visa_details')" class="ml-2"
                                          icon="mdi-equal-box"/>
                <v-flex sm3 xs6>
                  <list-item-detail :sub_title="getSelectedVisa.type"
                                    title="Visa Type"/>
                </v-flex>

                <v-flex sm3 xs6>
                  <list-item-detail
                      :sub_title="days+ ' Days'"
                      title="Visa Duration"/>
                </v-flex>
                <v-flex sm3 xs6>
                  <list-item-detail :sub_title="'$ ' + price"
                                    :title="$vuetify.lang.t('$vuetify.visa_cost')"/>
                </v-flex>
                <v-flex sm3 v-if="visa_type.slug === tourist_visa_slug" xs6>
                  <list-item-detail :sub_title="visa.purpose"
                                    :title="$vuetify.lang.t('$vuetify.purpose_of_visa')"/>
                </v-flex>

                <v-flex sm3 v-if="visa_type.slug === tourist_visa_slug" xs6>
                  <list-item-detail :sub_title="visa.extra.application_data.address"
                                    title="Address in Nepal">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 v-if="apply_type ==='arrival'" xs6>
                  <list-item-detail :sub_title="arrival_airport"
                                    :title="$vuetify.lang.t('$vuetify.arrival_airport')">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 v-if="apply_type ==='arrival'" xs6>
                  <list-item-detail :sub_title="last_arriving_country"
                                    :title="$vuetify.lang.t('$vuetify.last_arriving_country')">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 v-if="apply_type ==='arrival'" xs6>
                  <list-item-detail :sub_title="visa.extra.transport_no"
                                    :title="$vuetify.lang.t('$vuetify.transport_no')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 v-if="visa_type.slug === tourist_visa_slug" xs6>
                  <list-item-detail
                      :sub_title="visa.traveller.contact_no_nepal?visa.traveller.contact_no_nepal:'N/A'"
                      :title="$vuetify.lang.t('$vuetify.contact_no_nepal')"/>
                </v-flex>

                <v-flex sm3 v-if="visa.recommendation_letter_country" xs6>
                  <avatar-image-modal class="ml-4"
                                      :avatar="false"
                                      :src="visa.recommendation_letter_country"/>
                </v-flex>


                <v-flex sm3 v-if="visa_type.slug === transit_visa_slug" xs6>
                  <list-item-detail :sub_title="visa.extra.application_data.next_destination_country"
                                    :title="$vuetify.lang.t('$vuetify.next_destination_country')"/>
                </v-flex>
                <v-flex sm3 v-if="visa_type.slug === transit_visa_slug" xs6>
                  <list-item-detail :sub_title="visa.extra.application_data.next_flight_number"
                                    :title="$vuetify.lang.t('$vuetify.next_flight_number')"/>
                </v-flex>

                <v-flex class="mt-4 ml-4" v-if="visa.accompanied_by === 1" xs12>
                                    <span
                                        style="color: rgba(0,0,0,0.7);">{{
                                        $vuetify.lang.t('$vuetify.accompanied_by')
                                      }}</span>
                </v-flex>
                <v-flex sm3 v-if="visa.accompanied_by === 1" xs6>
                  <list-item-detail :sub_title="visa.accompanied_name"
                                    :title="$vuetify.lang.t('$vuetify.full_name')"/>
                </v-flex>

                <v-flex sm3 v-if="visa.accompanied_by === 1" xs6>
                  <list-item-detail :sub_title="visa.accompanied_passport_number"
                                    :title="$vuetify.lang.t('$vuetify.passport_number')"/>
                </v-flex>

                <v-flex sm3 v-if="visa.accompanied_by === 1" xs6>
                  <list-item-detail :sub_title="visa.accompanied_relation"
                                    :title="$vuetify.lang.t('$vuetify.relation')"/>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.personal_details')"
                                          class="ml-2"
                                          icon="mdi-account"/>

                <v-flex md3 sm6 xs6>
                  <list-item-detail :sub_title="visa.traveller.full_name"
                                    :title="$vuetify.lang.t('$vuetify.full_name')"/>
                </v-flex>

                <v-flex md3 sm6 x6>
                  <list-item-detail
                      :sub_title="nationalityParsed.country_name"
                      :title="$vuetify.lang.t('$vuetify.country')">
                  </list-item-detail>
                </v-flex>

                <v-flex md3 sm4 xs6>
                  <list-item-detail :sub_title="visa.traveller.dob"
                                    :title="$vuetify.lang.t('$vuetify.dob')">
                  </list-item-detail>
                </v-flex>

                <v-flex md3 sm4 xs6 v-if="apply_type === 'online' || apply_type === 'eta'">
                  <avatar-image-modal class="ml-4"
                                      :avatar="true"
                                      :src="visa.traveller.traveller_image"/>
                </v-flex>

                <v-flex md3 sm4 xs6>
                  <list-item-detail :sub_title="visa.traveller.gender"
                                    :title="$vuetify.lang.t('$vuetify.gender')">
                  </list-item-detail>
                </v-flex>

                <v-flex md3 sm4 xs6>
                  <list-item-detail :sub_title="visa.traveller.occupation"
                                    :title="$vuetify.lang.t('$vuetify.occupation')">
                  </list-item-detail>
                </v-flex>

                <v-flex md3 sm4 xs6>
                  <list-item-detail
                      :sub_title="visa.traveller.full_address"
                      :title="$vuetify.lang.t('$vuetify.address')+' of ' +nationalityParsed.country_name">
                  </list-item-detail>
                </v-flex>
                <v-flex md3 sm4 xs6>
                  <list-item-detail
                      :sub_title="nationalityParsed.std_code +' '+  visa.traveller.contact_number"
                      :title="$vuetify.lang.t('$vuetify.contact_number')+' of ' +nationalityParsed.country_name">
                  </list-item-detail>
                </v-flex>
                <v-flex md3 sm4 xs6>
                  <list-item-detail
                      :sub_title="visa.traveller.email?visa.traveller.email:'n/a'"
                      :title="$vuetify.lang.t('$vuetify.email')">
                  </list-item-detail>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text
                    :text="visa.apply_with_traveller_document?$vuetify.lang.t('$vuetify.traveller_document_details'):$vuetify.lang.t('$vuetify.passport_details')"
                    class="ml-2"
                    icon="mdi-passport"/>

                <v-flex sm3 v-if="!visa.apply_with_traveller_document">
                  <list-item-detail :sub_title="visa.passport.passport_type"
                                    :title="$vuetify.lang.t('$vuetify.passport_type')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 xs6 v-if="!visa.apply_with_traveller_document">
                  <list-item-detail :sub_title="visa.passport.passport_number"
                                    :title="$vuetify.lang.t('$vuetify.passport_number')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 xs6 v-if="!visa.apply_with_traveller_document">
                  <list-item-detail :sub_title="visa.passport.validity"
                                    :title="$vuetify.lang.t('$vuetify.passport_validity')">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 xs6 v-if="visa.apply_with_traveller_document">
                  <avatar-image-modal class="ml-4"
                                      :avatar="true"
                                      :src="visa.traveller_document"/>
                </v-flex>

                <v-flex md3 sm4 xs6
                        v-if="(apply_type === 'online' || apply_type === 'eta') && !visa.apply_with_traveller_document">
                  <avatar-image-modal class="ml-4"
                                      v-if="!showPassportFile"
                                      :avatar="true"
                                      :src="passport_image"/>
                  <list-item-detail :sub_title="passport_image"
                                    v-else
                                    :title="$vuetify.lang.t('$vuetify.passport_file')"/>

                </v-flex>

                <v-flex ml-4 xs12 v-if="visa.extra.extra_passport_country">
                  <h4>Extra Passport Detail</h4>
                </v-flex>


                <v-flex sm3 xs6 v-if="visa.extra.extra_passport_country">
                  <list-item-detail :sub_title="visa.extra.extra_passport_country"
                                    :title="$vuetify.lang.t('$vuetify.country')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 xs6 v-if="visa.extra.extra_passport_no">
                  <list-item-detail :sub_title="visa.extra.extra_passport_no"
                                    :title="$vuetify.lang.t('$vuetify.passport_number')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 xs6 v-if="visa.extra.application_data.diplomatic_mission_name">
                  <list-item-detail :sub_title="visa.extra.application_data.diplomatic_mission_name"
                                    :title="$vuetify.lang.t('$vuetify.diplomatic_mission_name')">
                  </list-item-detail>
                </v-flex>

                <v-flex sm3 xs6 v-if="visa.extra.application_data.position">
                  <list-item-detail :sub_title="visa.extra.application_data.position"
                                    :title="$vuetify.lang.t('$vuetify.position')">
                  </list-item-detail>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-flex xs12>
              <v-divider class="my-3"/>
            </v-flex>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs12 md12 v-if="isOnline">
                                                                        <span style="float:right">

                                    <v-spacer/>
                                    <v-btn
                                        @click="back"
                                        color="red darken-3"
                                        dark
                                        large
                                        :disabled="bankLoading || paymentLoading"
                                    >{{ $vuetify.lang.t('$vuetify.back') }}
                                    </v-btn>
                                                                          <!--                                    <v-btn-->
                                                                          <!--                                            :loading="paymentLoading"-->
                                                                          <!--                                            @click="confirmOnline"-->
                                                                          <!--                                            color="green darken-3"-->
                                                                          <!--                                            dark-->
                                                                          <!--                                            large-->
                                                                          <!--                                            :disabled="bankLoading"-->
                                                                          <!--                                    >{{$vuetify.lang.t('$vuetify.proceed_with_online_payment')}}-->
                                                                          <!--                                    </v-btn>-->
                                    <v-btn
                                        :loading="bankLoading"
                                        @click="confirm"
                                        color="blue darken-3"
                                        v-if="showOnlinePayment"
                                        dark
                                        large
                                        :disabled="paymentLoading"
                                    >
                                        {{ $vuetify.lang.t('$vuetify.pay_on_arrival') }}
                                    </v-btn>
                                    <v-btn
                                        :loading="bankLoading"
                                        @click="confirm"
                                        color="blue darken-3"
                                        v-if="!showOnlinePayment"
                                        dark
                                        large
                                        :disabled="paymentLoading"
                                    >{{ $vuetify.lang.t('$vuetify.confirm') }}
                                    </v-btn>
                                                                        </span>
                </v-flex>
                <v-flex md12 xs12 v-else>
                                    <span style="float:right">
                                    <v-spacer/>
                                     <v-btn
                                         @click="back"
                                         color="red darken-3"
                                         dark
                                         large
                                         :disabled="paymentLoading || bankLoading"
                                     >{{ $vuetify.lang.t('$vuetify.back') }}
                                    </v-btn>
                                      <!--                                    <v-btn-->
                                      <!--                                            :loading="paymentLoading"-->
                                      <!--                                            @click="confirmOnline"-->
                                      <!--                                            color="green darken-1"-->
                                      <!--                                            dark-->
                                      <!--                                            large-->
                                      <!--                                            v-if="showOnlinePayment"-->
                                      <!--                                            :disabled="bankLoading"-->
                                      <!--                                    >{{$vuetify.lang.t('$vuetify.proceed_with_online_payment')}}-->
                                      <!--                                    </v-btn>-->
                                    <v-btn
                                        :loading="bankLoading"
                                        @click="confirm"
                                        color="blue darken-3"
                                        dark
                                        v-if="showOnlinePayment"
                                        large
                                        :disabled="paymentLoading"
                                    >
                                        {{ $vuetify.lang.t('$vuetify.proceed_with_bank_payment') }}
                                    </v-btn>
                                        <v-btn
                                            :loading="bankLoading"
                                            @click="confirm"
                                            class="mr-3"
                                            color="blue darken-3"
                                            v-if="!showOnlinePayment"
                                            dark
                                            large
                                            :disabled="paymentLoading"
                                        >{{ $vuetify.lang.t('$vuetify.confirm') }}
                                    </v-btn>
                                  </span>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ListItemDetail from "../../components/ListItemDetail";
import AvatarImageModal from "../../components/AvatarImageModal";
import ToolBar from "../../components/ToolBar";
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import {tourist_visa_slug, transit_visa_slug} from "../../constant/appConstant";

export default {
  data: () => ({
    errors: [],
    tourist_visa_slug,
    transit_visa_slug,
    passport_image: '',
    showPassportFile: false,
    online: false,
    bankLoading: false,
    paymentLoading: false
  }),
  components: {
    ToolBar,
    ListItemDetail,
    AvatarImageModal,
    ConfirmationHeaderText
  },
  mounted() {
    if (this.apply_type === 'online' || this.apply_type === 'eta') {
      if (this.visa.passport.passport_image !== undefined) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(this.visa.passport.passport_image);
        let extension = this.visa.passport.passport_image.name.split('.').pop();
        if (extension.toLowerCase() === 'pdf' || extension.toLowerCase() === 'docx') {
          this.passport_image = this.visa.passport.passport_image.name;
        } else {
          this.showPassportFile = false;
          fileReader.addEventListener('load', () => {
            this.passport_image = fileReader.result;
          });
        }
      }

    }


  },

  methods: {
    ...mapActions("VisaSingle", ["saveVisa"]),
    ...mapActions({
      getVisaTypeDetail: "VisaTypeSingle/fetchDetail",
      fetchNationality: "CountryForTouristList/fetchAll"
    }),
    back() {
      this.$router.go(-1);
    },
    confirm() {
      this.bankLoading = true;
      this.visa.visa_type = this.condition.id;
      this.visa.visa_applied_type = 0;
      this.visa.days = this.days;
      this.visa.online_payment = 0;
      this.visa.online_payment = 0;
      let apply_type = this.$route.params.apply;

      this.saveVisa(apply_type)
          .then((res) => {
            this.errors = null;
            let office = this.office;
            let apply = this.apply_type;
            this.$store.commit("VisaSingle/resetState");
            this.$store.commit("VisaSingle/setPdfDetails", res.data);
            this.$router.push({
              name: "PrintApplication",
              params: {apply, office}
            });
            this.bankLoading = false;
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.$store.commit("Notification/showError", error.response.data.message);
            } else {
              this.errors = null;
              this.$store.commit('Notification/showError', "Something went wrong");
            }
            this.bankLoading = false;

          });
    },
    confirmOnline() {
      let apply_type = this.$route.params.apply;
      this.visa.visa_type = this.condition.id;
      this.visa.online_payment = 1;
      this.visa.days = this.days;
      this.paymentLoading = true;
      this.saveVisa(apply_type)
          .then((res) => {
            this.paymentLoading = false;
            window.location.href = res.data.payment_link;
          })
          .catch(() => {
            this.paymentLoading = false;
          });
    }
  },
  computed: {
    ...mapGetters("VisaSingle", ["price", "visa", "visaCatOptions", "days", "apply_type", "office"]),
    ...mapGetters('VisaType', ['condition', 'visa_type']),
    getSelectedVisa() {
      return this.$store.state.VisaType.visa_type;
    },
    visas() {
      return this.$store.state.VisaTypeList.all;
    },
    defaultLanguage() {
      return require("@/assets/flags/" + this.$vuetify.lang.current + ".png");
    },
    nationalities() {
      return this.$store.state.CountryForTouristList.all;
    },
    arrival_airport() {
      const airport = this.$store.state.AirPort.airports.find((airport) => airport.id === this.visa.arrival_airport);
      return airport.airport_name;
    },
    last_arriving_country() {
      const country = this.nationalities.find((n) => n.id === this.visa.last_arriving_country);
      return country.country_name;
    },
    nationalityParsed() {
      let country = this.nationalities.find((n) => n.id === this.visa.traveller.country);
      if (!country) {
        return [];
      }
      return country;
    },
    isOnline() {
      const apply_type = this.$route.params.apply;
      return apply_type.toLowerCase() === 'online';
    },
    showOnlinePayment() {
      const apply_type = this.$route.params.apply;
      if (apply_type !== 'entry') {
        const selected_office = this.$store.state.Office.offices.find((o) => o.slug.toLowerCase() === this.$route.params.office.toLowerCase());
        return selected_office.online_payment_active && this.price > 0;
      }
      return false;
    }
  }
};
</script>

<style type="text/css">
@media only screen and (max-width: 600px) {
  .v-toolbar__title {
    white-space: initial !important;
  }
}

</style>
